import { AgregationReportTable } from './AgregationReportTable';

export default AgregationReportTable;
